import React from 'react';
import { Link } from 'react-router-dom';
import { btnPrimary, btnSecondary } from '../components/ui/buttonStyles';
export function NotFound() {
  return <div className="mx-auto max-w-2xl px-5 py-24 text-center md:py-32" data-id="element-844" data-mp="w6do3uq8b64i">
      <p className="font-display text-8xl text-clay" data-id="element-845" data-mp="104bc4u89jm6b">404</p>
      <h1 className="mt-4 font-display text-4xl md:text-5xl" data-id="element-846" data-mp="155h6sxlhhjih">Cette page a fait son temps</h1>
      <p className="mt-4 text-muted" data-id="element-847" data-mp="1a4aiqll4h2gj">
        Comme les créateurs, certaines pages ne restent pas éternellement. Celle-ci n’existe plus — ou n’a jamais existé.
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-3" data-id="element-848" data-mp="1f10yt8wxfy1y">
        <Link to="/boutique" className={btnPrimary} data-id="element-849" data-mp="1jv56jue0oa43">
          Voir la boutique
        </Link>
        <Link to="/" className={btnSecondary} data-id="element-850" data-mp="1nu5nf7cxp2og">
          Accueil
        </Link>
      </div>
    </div>;
}